var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { displayModal, logoutUserThunk, selectAppContent } from "@adm-media/adam-store-plugin";
import { useSelector } from "react-redux";
import Button from "../Button";
import { useForcedEvaluationForm } from "../../../../hooks/useForcedEvaluationForm";
import { useAppDispatch } from "../../../../store";
import { FORCE_EVALUATION_FORM_MODAL } from "../../../modals";
import { Popconfirm } from "antd";
import { PathQueryParams } from "../../../../pages";
import { useDeleteQuery } from "../../../../hooks/useDeleteQuery";
export var LogoutButton = function (_a) {
    var className = _a.className;
    var dispatch = useAppDispatch();
    var contents = useSelector(selectAppContent);
    var showEvaluationFormPrompt = useForcedEvaluationForm().showEvaluationFormPrompt;
    var deleteQuery = useDeleteQuery().deleteQuery;
    var handleLogout = function () {
        if (showEvaluationFormPrompt) {
            dispatch(displayModal({
                name: FORCE_EVALUATION_FORM_MODAL
            }));
        }
        else
            dispatch(logoutUserThunk());
        deleteQuery(PathQueryParams.edl);
        deleteQuery("efo");
    };
    return (_jsx(Popconfirm
    // @ts-ignore TODO: add type in store
    , __assign({ 
        // @ts-ignore TODO: add type in store
        title: contents.confirm_logout_question || "Are you sure you want to logout?", okButtonProps: { "data-testid": "confirm-logout-button", className: "".concat(className, "__confirm-button") }, onConfirm: handleLogout, 
        // @ts-ignore TODO: add type in store
        okText: contents.confirm_logout_confirm || "Yes", 
        // @ts-ignore TODO: add type in store
        cancelText: contents.confirm_logout_cancel || "Cancel" }, { children: _jsx(Button, __assign({ "data-testid": "logout-button", className: className, type: "primary" }, { children: contents.logout })) })));
};
